import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;

const axios = createClient({ baseUrl, isAdminSite: true });

export const getAffiliateBanner = (data) => {
  return axios.post("/get_affiliates_banner", data);
};
export const getAffiliates = (data) => {
  return axios.post("/list_affiliates", data);
};
export const addEditAffiliatesBanner = (data) => {
  return axios.post("/add_edit_affiliates_banner", data);
};
export const addEditAffiliates = (data) => {
  return axios.post("/add_edit_affiliates", data);
};

export const deleteAffiliates = (data) => {
  return axios.post(`/delete_affiliates`, data);
};
